import { Fragment } from 'react'
import { AsideMenuItem } from './AsideMenuItem'
import { routes } from '../../routing/routes'
import useHasPermiso from '../../hooks/autenticacion/useHasPermiso'

/**
 * Renderiza los items del menu del sidebar segun permisos del usuario.
 * Inicio y Notificaciones son accesibles sin permiso explicito.
 */
export function AsideMenuMain() {
  const { hasPermiso } = useHasPermiso()

  return (
    <>
      {routes.map(({ nombre, icono, to, permisos, path }) => {
        if (hasPermiso(permisos) || path === 'inicio' || path === 'notificaciones') {
          return (
            <AsideMenuItem
              to={to}
              icon={icono}
              title={nombre}
              fontIcon='bi-app-indicator'
              key={nombre}
            />
          )
        } else {
          return <Fragment key={nombre}></Fragment>
        }
      })}
    </>
  )
}
